import { DefaultRegistryAgencyResponseData } from "./registryAgencyFilter.interface";

export const adaptRegistryAgency = (
  originalData: DefaultRegistryAgencyResponseData,
) => {
  const sortedEntries = Object.entries(originalData)
    .sort(([, a], [, b]) => a.viewOrder - b.viewOrder)
    .reduce((acc, [key, value]) => {
      acc[key] = value.displayValue;
      return acc;
    }, {} as Record<string, string>);

  return sortedEntries;
};

export const adaptRegistryAgencyName = (
  originalData: DefaultRegistryAgencyResponseData,
) => {
  const sortedEntries = Object.entries(originalData)
    .sort(([, a], [, b]) => a.viewOrder - b.viewOrder)
    .reduce((acc, [key, value]) => {
      acc[value.displayValue] = key;
      return acc;
    }, {} as Record<string, string>);

  return sortedEntries;
};
